import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { canAccessPage } from '../../utils/rolePermissions';

const NAV_ITEMS = [
  { to: '/', page: '', label: 'Overview', icon: 'bi-speedometer2', end: true },
  { to: '/data', page: 'data', label: 'Data', icon: 'bi-database' },
  { to: '/analytics', page: 'analytics', label: 'Analytics', icon: 'bi-graph-up' },
  { to: '/schedule', page: 'schedule', label: 'Schedule', icon: 'bi-calendar-check' },
  { to: '/logs', page: 'logs', label: 'Logs', icon: 'bi-terminal' },
  { to: '/webhooks', page: 'webhooks', label: 'Webhooks', icon: 'bi-broadcast' },
];

const Sidebar = () => {
  const { role } = useAuth();

  // Hiding a link is a courtesy, not a control — the router refuses the route
  // and the server refuses the API call for a role that may not have it.
  const visibleNavItems = NAV_ITEMS.filter(({ page }) => canAccessPage(role, page));
  const canOpenSettings = canAccessPage(role, 'settings');

  return (
    <nav className="sidebar" aria-label="Main navigation">
      {/* Brand monogram at top */}
      <div className="sidebar-monogram" aria-hidden="true">
        S
      </div>

      {/* Nav links — icon only, pushed down with spacing */}
      <ul className="sidebar-nav list-unstyled mb-0" role="list">
        {visibleNavItems.map(({ to, label, icon, end }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                `sidebar-nav-item${isActive ? ' active' : ''}`
              }
              title={label}
              aria-label={label}
            >
              <i className={`bi ${icon} sidebar-nav-item-icon`} aria-hidden="true" />
            </NavLink>
          </li>
        ))}
      </ul>

      {/* Footer — settings link */}
      {canOpenSettings && (
        <div className="sidebar-footer">
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              `sidebar-nav-item${isActive ? ' active' : ''}`
            }
            title="Settings"
            aria-label="Settings"
          >
            <i className="bi bi-gear sidebar-nav-item-icon" aria-hidden="true" />
          </NavLink>
        </div>
      )}
    </nav>
  );
};

export default Sidebar;
